<div class="overlay-container" [hidden]="!visible" (click)="stopVideo()">
   <ng-container *ngFor="let overlay of overlays; trackBy: overlayTrackBy">
       <ng-container [ngSwitch]="overlay.type">
           <eocm-button *ngSwitchCase="OverlayType.Button" [overlay]="overlay"></eocm-button>
           <eocm-image *ngSwitchCase="OverlayType.Image" [overlay]="overlay"></eocm-image>
           <eocm-default *ngSwitchDefault [overlay]="overlay"></eocm-default>
       </ng-container>
   </ng-container>

  <eocm-form *ngFor="let form of forms; trackBy: formTrackBy" [form]="form"></eocm-form>
</div>
